function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M35.1 12.12a16.28 16.28 0 00-26.87 7.9c-.13.52-.6.88-1.13.88H1.56c-.73 0-1.28-.66-1.14-1.37A24 24 0 0140.58 6.65l3.46-3.46A2.32 2.32 0 0148 4.83v12.98a2.32 2.32 0 01-2.32 2.32H32.7c-2.07 0-3.1-2.5-1.64-3.97l4.04-4.04zM2.32 27.87H15.3c2.07 0 3.1 2.5 1.64 3.97l-4.04 4.04a16.28 16.28 0 0026.87-7.9c.13-.52.6-.88 1.13-.88h5.54c.73 0 1.28.66 1.14 1.37A24 24 0 017.42 41.35l-3.46 3.46A2.32 2.32 0 010 43.17V30.19a2.32 2.32 0 012.32-2.32z",
  fillRule: "nonzero"
})));